import React from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../autosite logo oficial.png';
import { useTheme } from '../theme';

export default function CenterLogo() {
  const navigate = useNavigate();
  const isMobile = typeof window !== 'undefined' && window.innerWidth < 700;
  const { tokens, themeKey } = useTheme();
  const isDarkNeon = themeKey === 'darkNeon';
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        // Keep the same height and no extra padding/background across all themes
        height: isMobile ? 'auto' : 60,
        padding: 0,
        background: 'transparent',
        borderRadius: 0,
        width: 'fit-content'
      }}
    >
      <img
        src={logo}
        alt="logo"
        style={{
          display: 'block',
          height: 48,
          width: 'auto',
          borderRadius: 12,
          boxShadow: `0 2px 8px ${tokens.shadowSoft}`,
          // For Neon Dark explicitly use a white plate for maximum contrast, otherwise follow theme inverse
          background: isDarkNeon ? '#ffffff' : tokens.inverse,
          padding: 4,
          cursor: 'pointer',
          transform: isMobile ? 'translateX(-22px)' : undefined
        }}
        onClick={() => navigate('/')}
        title="Acasă"
      />
    </div>
  );
}
